// src/services/axiosInstance.ts (혹은 있는 곳)
import axios from 'axios';
import { getUserData } from "@/recoil/auth/recoilHelper";

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
});

axiosInstance.interceptors.request.use(
    (config) => {
        const userData = getUserData();
        if (userData) {
            config.headers = {
                ...config.headers,
                Authorization: 'Bearer ' + userData.token,
            };
        }
        return config;
    },
    (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const status = error?.response?.status;

        if (status === 401) {
            window.location.href = '/logout?type=token';
        } else if (status === 403) {
            window.location.href = '/logout?type=noAuth';
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
